module.exports = {
  BUILD_NUMBER: '2026-10-27',
  PROJECT_VERSION: "uhnEMR.0.167",
};
